import * as React from 'react'

export function unpackRef<T>(
  ref: React.RefObject<T | null> | undefined,
  fallback: T,
  count = 0,
): T {
  if (!ref?.current) {
    return unpackRef(ref, fallback, count + 1)
  }

  if (count > 250) {
    return fallback
  }

  return ref.current
}

export function createContext<T>(name: string, defaultValue: T) {
  const context = React.createContext<T>(defaultValue)

  function useHook() {
    const ctx = React.useContext<T>(context)

    if (!ctx) {
      throw new Error(`use${name} must be used within a ${name}Provider`)
    }

    return ctx
  }

  function Provider(props: React.PropsWithChildren<T>) {
    return <context.Provider value={props}>{props.children}</context.Provider>
  }

  Provider.displayName = `${name}Provider`

  return [Provider, useHook] as const
}
